import {get as _get} from 'lodash';

import DefaultForm from '@appComponents/DefaultForm';
import {convertToInt} from '@utils/helpers';
import {DISTRIBUTION_TYPE_LIVE} from '@constants/variables';
import {
    generateTunnelDropdownOptions,
    parseClientProductsForDropdown,
} from '@modules/events/utils/eventsConfigurationHelpers';

import {
    filterThirdPartyClientProducts,
    getThirdPartyDistribution,
} from '../../utils/thirdPartyClients';


export class ThirdPartyTunnelerPushForm extends DefaultForm {
    componentDidMount() {
        this.setCreateErrorCallback(() => {
            this.props.Modal.setModal({isVisible: false});
        });
    }

    getTunnelsNotBelongingToEncodingTargets = (clientProductsThirdParty, client, encodingTargetsTunnels) => {
        const clientTunnels = clientProductsThirdParty
            .filter((clientProduct) => convertToInt(clientProduct.client_product.client.id) === client)
            .map((clientProduct) => clientProduct.third_party_client_tunnels);
        const encodingTargetTunnelIds = encodingTargetsTunnels.map(tunnel => tunnel.vtd_tunnel_id);

        return clientTunnels.flat().filter(tunnel => !encodingTargetTunnelIds.includes(tunnel.vtd_tunnel_id));
    };

    componentDidUpdate(prevProps) {
        const clientProductsThirdParty = _get(this.props, 'GraphQLOptionsData.clientProductsThirdParty', null);
        const vtdTunnels = this.props.formParams.vtdTunnels;
        const {client} = this.props.formValues;

        if (clientProductsThirdParty
            && clientProductsThirdParty !== prevProps.GraphQLOptionsData.clientProductsThirdParty) {
            const distributions = this.props.formParams.eventContent.distributions,
                thirdPartyLiveDistribution = getThirdPartyDistribution(distributions, DISTRIBUTION_TYPE_LIVE),
                clientIds = thirdPartyLiveDistribution.clients.map((client) => (client.id)),
                clientSelectionType = convertToInt(thirdPartyLiveDistribution.client_selection_type.id),
                filteredData = filterThirdPartyClientProducts(clientProductsThirdParty, clientSelectionType, clientIds);

            this.setField('client', {
                options: parseClientProductsForDropdown(filteredData),
            });
        }

        if (client && client !== prevProps.formValues.client) {
            const filteredTunnels = this.getTunnelsNotBelongingToEncodingTargets(clientProductsThirdParty, client, this.props.formParams.encodingTargetsTunnels);

            this.setField('tunnel', {
                options: generateTunnelDropdownOptions(filteredTunnels, vtdTunnels),
                hidden: false,
                defaultValue: null,
            });
        }
    }

    prepareDataForSubmit = () => {
        return {
            eventContentId: convertToInt(this.props.formParams.eventContent.id),
            thirdPartyClientTunnel: convertToInt(this.props.formValues.tunnel),
        };
    };

    renderSaveButton = () => {
        return super.renderSaveButton({
            content: 'Save',
        });
    };
}
